import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React, { Fragment, useState, createContext } from 'react';
import { Provider } from 'react-redux';
import { ApolloProvider } from 'react-apollo';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { PersistGate } from 'redux-persist/es/integration/react';

import apolloClient from 'store/apolloClient';
import store, { persistor } from 'store/configureStore';
import IntlProvider from 'modules/language/components/IntlProvider';
import Pages from 'pages';
import getMuiTheme from 'styleVars/muiTheme';
import { switchColorsByAccessibilityOption } from './colors';

import Helmet from './helmet';

export const AccessibilityContext = createContext(null);

switchColorsByAccessibilityOption();

const App = () => {
  const [isAccessibilityEnabled, setAccessibilityEnabled] = useState(localStorage.getItem('ACCESSIBILITY_TURNED_ON') === 'true');

  const toggleAccessibilityMode = () => {
    switchColorsByAccessibilityOption(!isAccessibilityEnabled);

    setAccessibilityEnabled(!isAccessibilityEnabled);

    localStorage.setItem('ACCESSIBILITY_TURNED_ON', !isAccessibilityEnabled);
  };

  return (
    <MuiThemeProvider theme={ getMuiTheme(isAccessibilityEnabled) }>
      <ApolloProvider
        store={ store }
        client={ apolloClient }
      >
        <Fragment>
          <Provider store={ store }>
            <PersistGate
              loading={ null }
              persistor={ persistor }
            >
              <IntlProvider>
                <AccessibilityContext.Provider value={{ isAccessibilityEnabled, toggleAccessibilityMode }}>
                  <Pages />
                </AccessibilityContext.Provider>
                <Helmet />
              </IntlProvider>
            </PersistGate>
          </Provider>
        </Fragment>
      </ApolloProvider>
    </MuiThemeProvider>
  );
};

export default App;
